module.exports = __webpack_public_path__ + "8697f4d82965c8662e72108a2528633b.png";